export const logout = () => {
  localStorage.removeItem('authToken');
  window.location.href = '/aieaai';
};
// auth.js (demo helpers)
export const isDemoAuthEnabled = () =>
  process.env.REACT_APP_DEMO_AUTH === "1" && process.env.NODE_ENV !== "production";

export const setAuthToken = (token) => localStorage.setItem("authToken", token);
export const getAuthToken = () => localStorage.getItem("authToken");
export const clearAuthToken = () => localStorage.removeItem("authToken");

// Create a fake token + user
export const demoSignIn = () => {
  const token = `demo.${Date.now()}`;
  const user = {
    name: process.env.REACT_APP_DEMO_USER_NAME || "Demo User",
    email: process.env.REACT_APP_DEMO_USER_EMAIL || "demo@local.test",
    role: process.env.REACT_APP_DEMO_USER_ROLE || "user",
    mfaVerified: true,
    demo: true,
  };
  setAuthToken(token);
  localStorage.setItem("currentUser", JSON.stringify(user));
  return { token, user };
};
